/** Stable JSON for document fingerprints across browser objects and PostgreSQL JSONB. */
export function canonicalJsonStringify(value: unknown): string {
    const serialized = JSON.stringify(value, (_key, child: unknown) => {
        if (child === null || typeof child !== "object" || Array.isArray(child)) return child;
        const record = child as Record<string, unknown>;
        return Object.fromEntries(Object.keys(record).sort().map(key => [key, record[key]]));
    });
    if (serialized === undefined) throw new TypeError("Expected a JSON value");
    return serialized;
}

/** Compare decoded JSON values, ignoring object key order while preserving array order. */
export function jsonValuesEqual(left: unknown, right: unknown): boolean {
    if (left === right) return true;
    if (left === null || right === null || typeof left !== "object" || typeof right !== "object") {
        return false;
    }
    if (Array.isArray(left) || Array.isArray(right)) {
        return Array.isArray(left) && Array.isArray(right) &&
            left.length === right.length &&
            left.every((value, index) => jsonValuesEqual(value, right[index]));
    }
    const leftRecord = left as Record<string, unknown>;
    const rightRecord = right as Record<string, unknown>;
    const keys = Object.keys(leftRecord);
    return keys.length === Object.keys(rightRecord).length && keys.every(key =>
        Object.hasOwn(rightRecord, key) && jsonValuesEqual(leftRecord[key], rightRecord[key])
    );
}
